module.exports = __webpack_public_path__ + "media/6.2415ed1c.wav";